import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Helmet } from 'react-helmet';

import { InputWithConfirm, RadioOptionsWithConfirm, IQuestion } from 'shared-components';

import { ApplicationState } from '../../../../../store';
import * as StudentActions from '../../../../../store/student/actions';
import * as VPFActions from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import {
  createNavigateBackwardAction,
  createNavigateForwardAction,
  createNavigateToAction
} from '../../../../../middleware/actions';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { toggleTaskMenu } from '../../../../../store/ui/actions';
import { titleAppend } from '../../../../../utilities/head';

const VisaPrepFormUniEnrolmentPage3 = () => {
  // dispatch actions
  const dispatch = useDispatch();
  const onPrevious = () => dispatch(createNavigateBackwardAction());
  const onNext = () => {
    dispatch(StudentActions.saveVisaPrepForm(Pages.PAGE7_3));
    dispatch(createNavigateForwardAction());
  };
  const onSkip = () => dispatch(createNavigateForwardAction());
  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(VPFActions.createUpdateVPIFieldAction(fieldName, value, refValue));
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };

  // state props from store
  const visaPrepForm = useSelector(({ student }: ApplicationState) => student.visa, shallowEqual);
  const { appliedThroughUCAS, ucasPin } = visaPrepForm;

  // constants
  const currentStep = 3;
  const steps = 3;
  const sectionTitle = 'University Enrolment';

  // component state
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      appliedThroughUCAS,
      ucasPin
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, appliedThroughUCAS, ucasPin]);

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onPrevious={onPrevious}
      onNext={onNext}
      onSkip={onSkip}
      onBackToTaskList={onBackToTaskList}
      section={sectionTitle}
    >
      <Helmet>
        <title>
          {`${sectionTitle}: Step ${currentStep}`} {titleAppend}
        </title>
      </Helmet>

      <RadioOptionsWithConfirm
        key={VQ.APPLIED_THROUGH_UCAS}
        id={VQ.APPLIED_THROUGH_UCAS}
        label={'Did you apply for your course through UCAS?'}
        onClick={(question: IQuestion) => onChange(VQ.APPLIED_THROUGH_UCAS, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: appliedThroughUCAS === true
          },
          {
            char: 'N',
            label: 'No',
            selected: appliedThroughUCAS === false
          }
        ]}
      />

      {appliedThroughUCAS === true ? (
        <InputWithConfirm
          key={VQ.UCAS_PIN}
          id={VQ.UCAS_PIN}
          value={ucasPin}
          label={'What is your UCAS personal identification number?'}
          onChange={(evt: any) => {
            onChange(VQ.UCAS_PIN, evt.currentTarget.value);
          }}
        />
      ) : null}
    </QuestionPage>
  );
};
export default VisaPrepFormUniEnrolmentPage3;
